@if (loader) {
  <div class="loader-overlay"></div>
}
@if (loader) {
  <span id="loading"></span>
}

<nav class="wb-top">
  <div class="wb-contain wb-page-login">
    @if (form.config.logo) {
      <div class="wb-logo wb-page-login">
        <img src="{{form.config.logo}}" alt="logo">
      </div>
    }
    @if (!form.config.logo) {
      <h3 class="wb-logo wb-logotext wb-page-login wb-formtitle">{{form.name}}</h3>
    }
  </div>
</nav>

<form [formGroup]="formGroup" class="wb-form-container" autocomplete="off" (ngSubmit)="startLogin()">
  <!-- First field is to throw off browsers from using autocomplete -->
  <input autocomplete="off" name="hidden" type="text" style="display:none;">

  <h3>
    {{'login_title' | translate | ucFirst}}
  </h3>
  <div>
    {{'login_sub_title' | translate | ucFirst}}
  </div>

  <div class="field">
    <span class="wb-summary-name">
      {{'email' | translate | ucFirst}} <span
    class="wb-field-wrapper-required">*</span>
  </span>
  <ng-container>
    <input formControlName="email" type="text" id="email" [ngClass]="loginError ? 'error' : ''"
      placeholder="{{'email' | translate | ucFirst}}">
    </ng-container>
  </div>

  <div class="field">
    <span class="wb-summary-name">
      {{'password' | translate | ucFirst}} <span
    class="wb-field-wrapper-required">*</span>
  </span>
  <ng-container>
    <input formControlName="password" type="password" id="password" [ngClass]="loginError ? 'error' : ''"
      placeholder="{{'password' | translate | ucFirst}}">
    </ng-container>
  </div>
  <div class="field">
    <a class="yda-link forgot" flex href="#"
    routerLink="../password-reset">{{'forgot_password'|translate}}</a>
    <span class="separator"></span>
    <a
      href="dashboard/{{this.translate.currentLang.split('-')[0]}}/{{this.form.id}}/signup">{{'signup' |
      translate |
    ucFirst}}</a>
  </div>
  <nav class="wb-form wb-page-login" #formNavigation>
    @if (loginError) {
      <div class="errorMsg">
        {{loginError | translate | ucFirst}}
      </div>
    }
    <div class="wb-container">
      <button class="wb-next" (click)="startLogin()">
        {{'login' | translate | ucFirst}}
      </button>
      <button class="wb-previous"
        routerLink="/{{this.translate.currentLang.split('-')[0]}}/{{this.form.id}}">
        {{'back' | translate | ucFirst}}
      </button>
    </div>
  </nav>
</form>
